import { useEffect } from "react";

/**
 * Quantas telas estão em modo sessão agora.
 *
 * Um contador, e não um booleano: `Executar` e `Simulado` podem se suceder com
 * as duas montadas por um quadro durante a troca de rota, e um booleano
 * desligaria o modo no desmonte da primeira.
 */
let sessoesEmCurso = 0;

/**
 * Marca `<html data-sessao="ativa">` enquanto a tela que chama isto estiver no
 * ar. No tema Caderno (ADR 040) a sessão é a folha inteira: a folha esconde a
 * lateral, o cabeçalho do celular e a ilha lendo esse atributo.
 *
 * O fundo vivo que dava nome a este arquivo saiu com o Caderno: a folha é
 * papel pautado, parado.
 */
export function usarPausaDeMovimento(): void {
  useEffect(() => {
    sessoesEmCurso += 1;
    document.documentElement.setAttribute("data-sessao", "ativa");
    return () => {
      sessoesEmCurso -= 1;
      if (sessoesEmCurso === 0) document.documentElement.removeAttribute("data-sessao");
    };
  }, []);
}
